import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import AnimatedSection from '../components/AnimatedSection';
import './ContactPage.scss';

export default function ContactPage() {
  return (
    <>
      <Navbar />
      <main className="contact-page">
        <div className="container">
          <div className="contact-page__grid">
            <AnimatedSection className="contact-page__left">
              <p className="inner-page__label">Get In Touch</p>
              <h1 className="contact-page__title">
                Let's talk about your trade corridor
              </h1>
              <p className="contact-page__sub">
                We're in early conversations with traders, brokers and partners
                across African corridors. If you move goods, finance trade, or
                advise on credit risk — we want to hear from you.
              </p>

              <div className="contact-page__details">
                <div className="contact-page__detail">
                  <span className="contact-page__detail-label">Focus</span>
                  <span className="contact-page__detail-value">Nigeria & West Africa corridors</span>
                </div>
                <div className="contact-page__detail">
                  <span className="contact-page__detail-label">Stage</span>
                  <span className="contact-page__detail-value">Early conversations — shaping how we build</span>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection className="contact-page__right" delay={0.15}>
              <ContactForm />
            </AnimatedSection>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
